import React from "react";
import { useNavigate } from 'react-router-dom';
import slugify from "../../utils/slugify";

const GameCard = ({ game, index }) => {
  const navigate = useNavigate();

  const handleGameCardClick = (game) => {
    let path = game.slug;
    if (!path) {
      path = slugify(game.title);
    }
    navigate(`/game/${path}`, { state: { game } });
  };

  let imgSrc = game.thumb;
  if(game.inHouse){
    imgSrc = `/assets/${game.thumb}.webp`
  }
  return (
    <div
      className="gameCardClass w-24 sm:w-28 md:w-32 h-24 sm:h-28 md:h-32 flex-shrink-0 cursor-pointer relative group overflow-hidden rounded-md border border-[#00F0FF] hover:border-[#FF007F] transform hover:scale-105 transition duration-300"
      onClick={() => handleGameCardClick(game)}
    >
      {game.initial ?
        <img
          src={imgSrc}
          srcSet={`${game.thumb} 1x, ${game.thumb} 2x`}
          alt={game.slug}
          loading={index === 0 ? "eager" : "lazy"}
          fetchpriority={index === 0 ? "high" : undefined}
          className="w-full h-full object-cover absolute top-0 left-0 z-0 group-hover:opacity-90 transition duration-300"
        />
        :
        <img
          src={game.thumb}
          srcSet={`${game.thumb} 1x, ${game.thumb} 2x`}
          alt={game.slug}
          loading="lazy"
          className="w-full h-full object-cover absolute top-0 left-0 z-0 group-hover:opacity-90 transition duration-300"
        />}


      <div className="absolute bottom-0 w-full p-1 sm:p-2 z-10 backdrop-blur-md bg-black/40">
        <h3 className="text-[10px] sm:text-xs font-bold text-[#00F0FF] text-center truncate">
          {game.title}
        </h3>
      </div>
    </div>
  );
};

export default GameCard;
